// extracted by mini-css-extract-plugin
module.exports = {"root":"BackImages_root__1USUg","title":"BackImages_title__2xkLm","images":"BackImages_images__QSn9S"};